import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import _ from "lodash";
import {roomUXService} from "@/core/service/room.ux.service";

class RoomUXApi extends BaseApi {
  #UXData

  constructor() {
    super()
    Room.UX = this
  }

  async setGroupInfo(groupId) {
    if(!groupId) return;

    const { data } = await roomUXService.getGroupUX(groupId)
    this.#UXData = data

    console.log('# UX Data Init', data)

    return data
  }

  getGroupData(){
    return this.#UXData;
  }
}

export const roomUXApi = new RoomUXApi();